import {
  FeedbackMessages,
  useFeedback,
} from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';
import { Operations as DocumentDetailsOperations } from '@/modules/documents/graphql/DocumentDetails.generated';
import { Operations as EntityDetailsOperations } from '@/modules/entities/details/graphql/EntityDetailPage.generated';

import { useDeleteSummaryMutation } from './graphql/DeleteSummary.generated';

interface UseDeleteSummaryInput {
  documentId: string;
  onSuccess?: () => void;
}

export function useDeleteSummary({
  documentId,
  onSuccess,
}: UseDeleteSummaryInput) {
  const { showFeedback, createSuccessFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [deleteSummary, { loading }] = useDeleteSummaryMutation({
    refetchQueries: [
      EntityDetailsOperations.Query.EntityDetails,
      DocumentDetailsOperations.Query.DocumentDetails,
    ],
    onCompleted: () => {
      createSuccessFeedback('Summary deleted successfully')();
      onSuccess?.();
    },
    onError: (error) => {
      showFeedback(FeedbackMessages.formSaveError);
      reportError('Failed to delete summary for document', error, {
        documentId,
      });
    },
  });

  return { deleteSummary, loading };
}
